import { gql } from '@apollo/client';

// ==================== QUERIES ====================

export const GET_TAX_BASED_AMOUNT_CONFIG = gql`
  query GetTaxBasedAmountConfig {
    getTaxBasedAmountConfig {
      id
      taxedTargetAmount
      taxedAlertAmount
      exemptTargetAmount
      exemptAlertAmount
      lastTaxedAmount
      lastExemptAmount
      lastCheckDate
      createdAt
      updatedAt
    }
  }
`;

export const GET_TAX_AMOUNT_STATUS = gql`
  query GetTaxAmountStatus($date: DateTime) {
    getTaxAmountStatus(date: $date) {
      taxedAmount
      taxedTarget
      taxedAlert
      taxedPercentage
      taxedAlertTriggered
      taxedReached
      exemptAmount
      exemptTarget
      exemptAlert
      exemptPercentage
      exemptAlertTriggered
      exemptReached
      date
    }
  }
`;

export const GET_TAX_AMOUNT_HISTORY = gql`
  query GetTaxAmountHistory($startDate: DateTime, $endDate: DateTime, $limit: Int) {
    getTaxAmountHistory(startDate: $startDate, endDate: $endDate, limit: $limit) {
      id
      date
      taxedAmount
      exemptAmount
      taxedTarget
      exemptTarget
      taxedReached
      exemptReached
      createdAt
    }
  }
`;

export const GET_TAX_AMOUNT_STATISTICS = gql`
  query GetTaxAmountStatistics($startDate: DateTime, $endDate: DateTime) {
    getTaxAmountStatistics(startDate: $startDate, endDate: $endDate) {
      totalDays
      taxedAverage
      exemptAverage
      taxedReachedCount
      exemptReachedCount
      bothReachedCount
    }
  }
`;

// ==================== MUTATIONS ====================

export const UPDATE_TAX_BASED_AMOUNT_CONFIG = gql`
  mutation UpdateTaxBasedAmountConfig($input: UpdateTaxConfigInput!) {
    updateTaxBasedAmountConfig(input: $input) {
      id
      taxedTargetAmount
      taxedAlertAmount
      exemptTargetAmount
      exemptAlertAmount
      lastTaxedAmount
      lastExemptAmount
      lastCheckDate
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_TAX_CURRENT_AMOUNTS = gql`
  mutation UpdateTaxCurrentAmounts($taxedAmount: Float!, $exemptAmount: Float!, $date: DateTime) {
    updateTaxCurrentAmounts(taxedAmount: $taxedAmount, exemptAmount: $exemptAmount, date: $date)
  }
`;
